import { Box, FormControlLabel, Switch } from '@mui/material';
import { BoxProps } from '@mui/material/Box/Box';
import { useTranslation } from 'react-i18next';

import { UseWorkflowReportCellRenderTogglesOutput } from '~/scenes/PortalModules/Analytics/People/WorkflowReport/Common/components/WorkflowReportCellRenderToggles';

import { ToggleKey } from '../../../types';

type PropsType = UseWorkflowReportCellRenderTogglesOutput &
  BoxProps & {
    visibleToggles?: ToggleKey[];
  };

export const WorkflowReportCellRenderToggles = (props: PropsType) => {
  const {
    cellRenderState,
    onCellRenderStateChange,
    visibleToggles,
    ...boxProps
  } = props;
  const { t } = useTranslation();

  const allToggles = [
    {
      key: 'showChanges' as const,
      label: t('laShowChanges'),
      value: cellRenderState.showChanges,
    },
    {
      key: 'showHistory' as const,
      label: t('laShowHistory'),
      value: cellRenderState.showHistory,
    },
  ];

  const togglesConfig = visibleToggles
    ? allToggles.filter((toggle) => visibleToggles.includes(toggle.key))
    : allToggles;

  return (
    <Box {...boxProps}>
      {togglesConfig.map(({ key, label, value }) => {
        return (
          <FormControlLabel
            key={key}
            control={<Switch />}
            label={label}
            checked={value}
            onChange={(_event, checked) => {
              onCellRenderStateChange({ ...cellRenderState, [key]: checked });
            }}
          />
        );
      })}
    </Box>
  );
};
